import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/operating-margin-calculator',
  component: () => import('../../routes/OperatingMarginCalculator.svelte'),
  card: {
    id: 'operating-margin',
    title: 'Operating Margin',
    description: 'Calculate operating margin to measure operational efficiency and profitability.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/operating-margin-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Operating Margin Calculator – Measure Operational Efficiency',
    description: 'Free operating margin calculator. Calculate what percentage of revenue is left after covering operating expenses. Includes interpretation benchmarks and industry comparisons.',
  },
};

export default meta;
